import * as AF from "@/components/form-items/AbstractForm";
import { useAuth } from "@/context/auth/AuthContext";
import useImageAttachment from "@/hooks/useImageAttachment";
import { SupportedLocale } from "@/i18n";
import { generateImageName } from "@/lib/utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CroppedImageInput } from "../form-fields/CroppedImageInput";

interface LoginSignupFormProps {
  language: SupportedLocale;
}

export const LoginSignupForm = ({ language }: LoginSignupFormProps) => {
  const { t } = useTranslation();
  const { instanceData } = useAuth();

  const imagePosition = useMemo(
    () => `authPage${language.toLocaleUpperCase()}`,
    [language],
  );

  const { attachment, imageURL, refetch } = useImageAttachment(
    imagePosition,
    instanceData?.id,
  );
  return (
    <AF.Col>
      <CroppedImageInput
        imageURL={imageURL}
        attachment={attachment}
        refetch={refetch}
        imagePosition={imagePosition}
        aspect={0.78}
        title={t("addImageLabel")}
        buttonLabel={t("cmsChangerImageBouton")}
        label={t("cms.authentication.form.image")}
        buildImageName={(instanceName) =>
          generateImageName({
            primaryType: "CMSPages",
            instanceName,
            translatedPageName: t("seo.imageName.login"),
          })
        }
      />
      <AF.Text
        name={`login.${language}.pageName`}
        label={t("cms.login.form.pageName")}
      />
      <AF.RichText
        name={`login.${language}.subtitle`}
        label={t("cms.login.form.subtitle")}
      />
      <AF.Text
        name={`signup.${language}.pageName`}
        label={t("cms.signup.form.pageName")}
      />
      <AF.RichText
        name={`signup.${language}.subtitle`}
        label={t("cms.signup.form.subtitle")}
      />
    </AF.Col>
  );
};
